import { useNavigate } from 'react-router-dom'
import { persistor, useAppDispatch, useAppSelector } from '../../../redux/store'

export function useDoctorProfile() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const currentPatient = useAppSelector((state) => state.currentPatientPortal.currentPatient)
  const currentVisit = useAppSelector((state) => state.lobbyPortal.currentVisit)
  const isRefreshDisabled = Boolean(currentPatient || currentVisit)

  function formatPhoneNumber(num?: string | null) {
    if (!num) return ''

    // 1. Remove all non-digit characters
    let digits = num.replace(/\D/g, '')

    // 2. Strip known country codes
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.slice(1)
    } else if (digits.length === 12 && digits.startsWith('91')) {
      digits = digits.slice(2)
    }

    // 3. Format only if exactly 10 digits remain
    if (digits.length !== 10) return num

    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
  }

  const clearAllTokens = () => {
    // Save the admin_token and studio_details before clearing
    // const adminToken = localStorage.getItem(AppConstant.ADMIN_TOKEN)
    // const studioDetails: any = localStorage.getItem(AppConstant.STUDIO_DETAILS)

    // Clear all localStorage and purge persistor
    persistor.purge()
    localStorage.clear()
    window.location.reload()
    setTimeout(() => {
      navigate('/doctor-login')
    }, 1000)

    // Restore only the admin_token and studio_details
    // if (adminToken && studioDetails) {
    //   localStorage.setItem(AppConstant.ADMIN_TOKEN, adminToken)
    //   localStorage.setItem(AppConstant.STUDIO_DETAILS, studioDetails)
    // }
  }

  const pageRefresh = () => {
    window.location.reload()
  }

  return {
    clearAllTokens,
    pageRefresh,
    formatPhoneNumber,
    isRefreshDisabled,
  }
}
